<template>
    <div :class="`m-portal .m-portal-nav-left ${currentModule}`">
        <el-button type="success" @click="handleArtiList('article','type1')">文章列表1</el-button>
        <el-button type="success" @click="handleArtiList('article','type2')">文件列表2</el-button>
        <el-button type="success" @click="handleNewList('news','type1')">新闻类别1</el-button>
        <el-button type="success" @click="handleNewList('news','type2')">新闻类别2</el-button>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                msg: 'app'
            }
        },
        computed: {
            currentModule() {
                return `${this.$route.params._module}_${this.$route.params._field}`;
            }
        },
        methods: {
            handleNewList(moudle, field) {
                this.$router.push({
                    path: `/portal/new/list/${moudle}/${field}`
                });
            },
            handleNewDetail(moudle, field, item) {
                this.$router.push({
                    path: `/portal/new/detail/${moudle}/${field}/${item.newId}`
                });
            },
            handleArtiList(moudle, field) {
                this.$router.push({
                    path: `/portal/arti/list/${moudle}/${field}`
                });
            },
            handleArtiDetail(moudle, field, item) {
                this.$router.push({
                    path: `/portal/arti/detail/${moudle}/${field}/${item.artiId}`
                });
            }
        },
        created() {

        }
    }
</script>

<style scoped>

</style>